import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page83() {
  useEffect(() => {
    document.title = "Маяк — Страница 82"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page81" />
        <ForwardLink href="/page83" />
      </div>

      <p style={{ textAlign: "right" }}>82.</p>
      <p>Смеются...</p>
      <p>Смеются...</p>
      <p>Смеются...</p>
      <p>Смеются...</p>
      <p>ЗАДЕРЖКА.</p>
      <p>ЧЕРНЫЙ ЭКРАН.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – УТРО</p>
      <p>
        КУХНЯ – это абсолютная катастрофа. Как бы ужасно она<br/>
        ни выглядела прошлой ночью, сейчас стало еще хуже. Повсюду<br/>
        беспорядок и каждая поверхность насквозь мокрая. Вода капает<br/>
        таким образом, что можно предположить, что шторм закончился. Помещения полностью<br/>
        разрушены, и, судя по всему, не только из-за шторма.
      </p>
      <p>ТОПОР все еще лежит в столе.</p>
      <p>
        МОЛОДОЙ сидит в РАКОВИНЕ, пьет СКИПИДАР прямо<br/>
        из банки. Он в майке и трусах, но все еще<br/>
        носит спасательный жилет.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Это место – свинарник.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        И тебе доброе утро.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я бы хотел пойти на прогулку.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        Кто ж тебя держит. Смотри – не утони.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ГОСТИНАЯ – ПОЗЖЕ</p>
      <p>ЧАСЫ монотонно тикают.</p>
      <p>
        Комната наполовину затоплена. МОЛОДОЙ стоит по щиколотку в воде,<br/>
        мочится, промахивается в ночной горшок, следует за ним, пока он<br/>
        плывет по комнате. Одновременно он снимает<br/>
        спасательный жилет...
      </p>
      <p>Внезапно его начинает тошнить... его рвет.</p>
      <p>Он падает на колени... всплеск... и он видит...</p>
      <p>ЖУРНАЛ СТАРИКА... проплывает мимо... ОТКРЫТЫЙ.</p>
      <p style={{ textAlign: "right" }}>82.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page81" />
        <ForwardLink href="/page83" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710717329/the-lighthouse-script/adsspi5sk2tj2qqxl4tc.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page83;
